import React from 'react';

import { useMindmap } from '../../../../pages/mindmap/use-mindmap';

export const FormatTextContentMenuStylingSector = () => {
  const {
    textFormatting: { toggleSelectedTextFormat, selectedTextFormats },
  } = useMindmap();

  const toggleBold = () => toggleSelectedTextFormat({ type: 'bold' });

  const toggleItalic = () => toggleSelectedTextFormat({ type: 'italic' });

  const toggleSizeUp = () => toggleSelectedTextFormat({ type: 'size', enlarge: true });

  const toggleLight = () => toggleSelectedTextFormat({ type: 'light' });

  const toggleMonospace = () => toggleSelectedTextFormat({ type: 'monospace' });

  const toggleSizeDown = () => toggleSelectedTextFormat({ type: 'size', enlarge: false });

  return (
    <>
      {/* bold */}
      <div style={{ gridColumn: '1 / 2', gridRow: '1 / 2' }} onClick={toggleBold}>
        <i className={`context-menu-icon pi ri-bold ${selectedTextFormats?.bold.value ? 'enabled' : ''}`}></i>
      </div>
      {/* italic */}
      <div style={{ gridColumn: '2 / 3', gridRow: '1 / 2' }} onClick={toggleItalic}>
        <i className={`context-menu-icon pi ri-italic ${selectedTextFormats?.italic.value ? 'enabled' : ''}`}></i>
      </div>
      {/* size-up */}
      <div style={{ gridColumn: '3 / 4', gridRow: '1 / 2' }} onClick={toggleSizeUp}>
        <i className="context-menu-icon pi pi-angle-double-up "></i>
      </div>
      {/* light */}
      <div style={{ gridColumn: '1 / 2', gridRow: '2 / 3' }} onClick={toggleLight}>
        <i className={`context-menu-icon pi ri-text ${selectedTextFormats?.light.value ? 'enabled' : ''}`}></i>
      </div>
      {/* monospace */}
      <div style={{ gridColumn: '2 / 3', gridRow: '2 / 3' }} onClick={toggleMonospace}>
        <i className={`context-menu-icon pi ri-terminal-line ${selectedTextFormats?.monospace.value ? 'enabled' : ''}`}></i>
      </div>
      {/* size-down */}
      <div style={{ gridColumn: '3 / 4', gridRow: '2 / 3' }} onClick={toggleSizeDown}>
        <i className="context-menu-icon pi pi-angle-double-down "></i>
      </div>
    </>
  );
};
